import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, Typography } from '@klp/design';
import { makeStyles } from '@material-ui/core';
import { KlpPalette } from '@klp/design/Theme/KlpPalette';
import { KlpFontVariant } from '@klp/design/Theme/KlpFontVariant';
import type { ISakStatistics } from './services/rtkApi';

export enum SakStatus {
    AKTIV = 'Aktiv',
    VENTER_PAA_KUNDE = 'Venter på kunde',
    VENTER_PAA_TREDJEPART = 'Venter på 3dje part',
    PAABORJAD = 'Påbörjad',
    EJ_PAABORJAD = 'Ej påbörjad',
}

const RELEVANT_STATUSES: Array<SakStatus> = [
    SakStatus.AKTIV,
    SakStatus.VENTER_PAA_KUNDE,
    SakStatus.VENTER_PAA_TREDJEPART,
    SakStatus.PAABORJAD,
    SakStatus.EJ_PAABORJAD,
];

type SakSummaryStatisticsProps = {
    statistics?: Array<ISakStatistics>;
};

const useStyles = makeStyles((theme) => ({
    greenText: {
        color: KlpPalette.secondary.main,
    },
    text: {
        paddingTop: theme.spacing(0.625),
        paddingLeft: theme.spacing(0.25),
        fontSize: KlpFontVariant.small.fontSize,
    },
}));

export const SakSummaryStatistics: React.FC<SakSummaryStatisticsProps> = ({
    statistics,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const filteredStatistics = statistics?.filter((stat) =>
        RELEVANT_STATUSES.includes(stat.statusName as SakStatus),
    );

    if (!statistics || filteredStatistics?.length === 0) {
        return (
            <Typography klpTypographyVariant="epsilon">
                {t('frontPage.sak.noTickets')}
            </Typography>
        );
    }

    return (
        <Block marginBottom="bulky">
            {filteredStatistics?.map((stat) => (
                <Typography
                    key={stat.statusName}
                    klpTypographyVariant="epsilon"
                >
                    <span className={classes.greenText}>
                        {stat.statusCount}{' '}
                    </span>
                    &nbsp;
                    <span className={classes.text}>
                        {t(`frontPage.sak.sakStatus.${stat.statusName}`)}
                    </span>
                </Typography>
            ))}
        </Block>
    );
};
